(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-autumn-header"]) return;
  try {
    
  if (!customElements.get('gt-autumn-navigation')) {
    customElements.define('gt-autumn-navigation',class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const header = this.closest('.gta-header');
        if (header) {
          this.resizeObserver = new ResizeObserver(([entry])=>{
            const height = Math.round(entry.borderBoxSize[0]?.blockSize || header.offsetHeight);
            document.body.style.setProperty('--header-height',`${height}px`);
            document.body.style.setProperty('--header-group-height',`${height}px`);
          });
          this.resizeObserver.observe(header);
        }
        this.addEventListener('click',event=>{
          const summary = event.target.closest('summary');
          if (summary) {
            const details = summary.parentElement;
            if (details.matches('[data-gta-submenu]') && !details.open) {
              this.querySelectorAll('[data-gta-submenu][open]').forEach(other=>{if(other!==details) other.open=false;});
            }
          }
          if(event.target.closest('a')) this.closeMenus();
        },{signal});
        this.addEventListener('keydown',event=>{
          if(event.key==='Escape') {
            const current=event.target.closest('details[open]');
            if(current) { event.preventDefault(); current.open=false; current.querySelector('summary')?.focus(); }
          }
        },{signal});
        document.addEventListener('click',event=>{if(!this.contains(event.target)) this.closeMenus();},{signal});
        this.addEventListener('focusout',()=>{requestAnimationFrame(()=>{if(!this.contains(document.activeElement)) this.closeMenus();});},{signal});
      }
      closeMenus() { this.querySelectorAll('details[open]').forEach(details=>details.open=false); }
      disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
